import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (sessionId) {
        try {
          await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        } catch { /* ignore, will fall through to login */ }
      }
      // clear the session_id from the URL BEFORE refreshing so checkAuth runs
      window.history.replaceState(null, "", "/app");
      await refresh();
      navigate("/app", { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-reveal-black flex items-center justify-center text-reveal-cream/60 font-body" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
